import React from "react";
import { Droppable } from "react-beautiful-dnd";
import { DraggableColumnItem } from "./DraggableColumnItem";

interface BasketProps {
  title: string;
  columns: string[];
  id: string;
  divStyle?: string;
  wrap: boolean;
}

export const DroppableSettingsBasket: React.FC<BasketProps> = ({
  title,
  id,
  columns,
  divStyle,
  wrap,
}) => {
  const basketStyle = divStyle ? divStyle : "flex-grow mx-auto px-1";
  const containerWidth = wrap ? "min-w-1/4" : "";

  return (
    <div className={`px-1 text-center ${containerWidth}`}>
      <div className='text-2xl text-brand-blue'>{title.toUpperCase()}</div>
      <Droppable droppableId={id}>
        {(provided, snapshot) => {
          const BasketBG = snapshot.isDraggingOver
            ? "bg-green-200"
            : "bg-brand-white";
          return (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className={`${basketStyle} border border-solid border-gray-200 rounded shadow-xl ${BasketBG}`}
            >
              {provided.placeholder}
              {columns.map((column, index) => (
                <DraggableColumnItem
                  key={column}
                  item={column}
                  id={column}
                  index={index}
                  wrap={wrap}
                />
              ))}
            </div>
          );
        }}
      </Droppable>
    </div>
  );
};
